import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function PipeInsulationIcon(props) {
	return (
		<IconBase type="pipe-insulation" {...props}>
			<path d="M13 12.9778V15H9.91836L8.04272 8H11.6662L13 12.9778Z" />
			<path d="M12.1838 8H13V11.046L12.1838 8Z" />
			<path d="M14.5 18C13.9477 18 13.5 17.1221 13.5 16.0176V8H18.5V16.0176C18.5 16.7219 18.6821 17.3412 18.9572 17.6976C18.9839 17.7322 19 17.7741 19 17.8178C19 17.9184 18.9184 18 18.8178 18H14.5Z" />
			<path d="M19 8V15H20V8H19Z" />
			<path d="M4 10.2988V15H5.25968L4 10.2988Z" />
			<path d="M9.40073 15H5.77732L4 8.36697V8H7.52508L9.40073 15Z" />
			<path d="M2 9.5H3.5V13.5H2V9.5Z" />
			<path d="M22 9.5H20.5V13.5H22V9.5Z" />
		</IconBase>
	);
}
PipeInsulationIcon.propTypes = iconPropTypes;
